module.exports = __webpack_public_path__ + "img/39.44c09301.png";